import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/articles';

export default function NewsSection() {
  const displayArticles = articles.slice(0, 3);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            影视资讯
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            最新影视动态、观影指南、追剧技巧
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {displayArticles.map((article) => (
            <ArticleCard
              key={article.id}
              id={article.id}
              title={article.title}
              summary={article.summary}
              author={article.author}
              date={article.date}
              category={article.category}
              imageUrl={article.imageUrl}
              tags={article.tags}
            />
          ))}
        </div>
      </div>
    </section>
  );
}